export default __webpack_public_path__ + "static/media/POPPINS-THINITALIC.01dc641d.TTF";